var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticClass: "popbox",
      attrs: {
        name: "dialog2",
        title: "参数",
        width: 800,
        "show-confirm": false,
        "append-to-body": "",
      },
      on: { open: _vm.open, "after-close": _vm.handleAfterClose },
      model: {
        value: _vm.isShow,
        callback: function ($$v) {
          _vm.isShow = $$v
        },
        expression: "isShow",
      },
    },
    [
      _vm.topicType === "diy"
        ? _c(
            "v-button",
            {
              staticClass: "mb10",
              attrs: { type: "primary", name: "" },
              on: { click: _vm.openAddModel },
            },
            [_vm._v(" 新增参数 ")]
          )
        : _vm._e(),
      _c(
        "vxe-table",
        { attrs: { "row-id": "id", data: _vm.list, align: "left" } },
        [
          _c("vxe-table-column", {
            attrs: {
              field: "name",
              "show-overflow": "",
              "min-width": "200",
              title: "字段名称",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "identifier",
              "show-overflow": "",
              "min-width": "200",
              title: "字段标识",
            },
          }),
          _c("vxe-table-column", {
            attrs: {
              field: "data_type_t",
              "show-overflow": "",
              "min-width": "200",
              title: "数据类型",
            },
          }),
          _vm.topicType === "diy"
            ? _c("vxe-column", {
                attrs: { title: "操作", "min-width": "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (slotProps) {
                        return [
                          _c(
                            "span",
                            { staticClass: "handle-button" },
                            [
                              _c(
                                "v-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "S",
                                    type: "text",
                                    name: "btn-text1",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUpdateModel(slotProps.row)
                                    },
                                  },
                                  slot: "reference",
                                },
                                [_vm._v("编辑")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            { staticClass: "handle-button" },
                            [
                              _c(
                                "v-button",
                                {
                                  attrs: {
                                    slot: "reference",
                                    size: "S",
                                    type: "text",
                                    name: "btn-text1",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDelModel(slotProps.row)
                                    },
                                  },
                                  slot: "reference",
                                },
                                [_vm._v("删除")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  202383755
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("Params", {
        attrs: {
          showInputDialog: _vm.addloading,
          list: _vm.list,
          row: _vm.row,
          type: _vm.type,
          topicId: _vm.id,
          category: _vm.category,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.addloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.addloading = $event
          },
          change: _vm.getData,
        },
      }),
      _c("Del", {
        attrs: { showInputDialog: _vm.delloading, row: _vm.row },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.delloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.delloading = $event
          },
          change: _vm.getData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }